import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { DatasetProviderDashboardComponent } from '../../shared/components/dataset-provider-dashboard/dataset-provider-dashboard.component';
import { RolesApiService } from '@angular-workspace/services';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-consumer-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    DatasetProviderDashboardComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class ConsumerDashboardComponent implements OnInit {
  private rolesService = inject(RolesApiService);
  private router = inject(Router);
  private toasterService = inject(ToasterService);

  canAccess = false;
  isChecking = true;

  async ngOnInit(): Promise<void> {
    await this.checkConsumerRole();
  }

  private async checkConsumerRole(): Promise<void> {
    try {
      await this.rolesService.getRoles();
      const userRoles = this.rolesService.getUserRoles();

      if (userRoles && userRoles.length > 0) {
        const highestRolePanelRoute = this.rolesService.getHighestRolePanelRoute(userRoles);

        if (!highestRolePanelRoute.startsWith('/consumer')) {
          this.toasterService.warning("You don't have access to some of the panels.");
          this.router.navigate(['/'], { replaceUrl: true });
          return;
        }

        this.canAccess = true;
      } else {
        this.canAccess = true;
      }
    } catch (error) {
      console.error('Error checking roles:', error);
      this.canAccess = true;
    } finally {
      this.isChecking = false;
    }
  }
}
